// Shared column layout for the list-mode header + rows. Header and row use IDENTICAL class
// strings per column so the cells stay vertically aligned. Adjust widths here once and both
// files inherit the change.

export const COL = {
    source: 'flex shrink-0 items-center gap-1.5 w-[60px]',
    name: 'min-w-0 flex-1 truncate',
    author: 'hidden shrink-0 truncate text-xs text-fg-secondary sm:block w-[160px]',
    kind: 'hidden shrink-0 text-xs text-fg-muted sm:block w-[64px]',
    install: 'hidden shrink-0 md:block w-[80px]',
    mirror: 'hidden shrink-0 md:block w-[120px]',
    last: 'hidden shrink-0 text-right font-mono text-[11px] text-fg-muted lg:block w-[72px]',
} as const;

export const ROW_FRAME =
    'flex items-center gap-4 border-b border-rule px-4 py-2.5 transition-colors';
